<template>
    <div>
        <a @click="DefaultLogin()" class="btn btn-primary btn-xnax-login ">Default Login</a>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    // import AccountsSelectBox from '../utility/AccountsSelectBox'
    import AppUtils from "../../utils/BaseUtils/AppUtils";
    import StoreUtils from "../../utils/BaseUtils/StoreUtils";

    export default {
        name: "DefaultLogin",
        components: {},
        props: { },
        data () {
            return {}
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
            ])
        },
        created () {},
        methods: {
            ...mapActions([
                'updateAppLoading',
                'updateCurrentComponent',
                'updateDataOnLogin',
                'updateUsername',
            ]),

            DefaultLogin(){
                // console.log('Default Login')
                //start running
                this.updateAppLoading(true);

                //set Username
                this.updateUsername('lumbex');


                //Consume Login API
                axios({
                    method:'post',
                    url:'/logincustomer',
                    headers:{'Authorization': null},
                    data:{
                        username: '',
                        password: '',
                        appversion: "1.0",
                        deviceplatform: "web",
                        mobiledeviceid: `${AppUtils.getDeviceId()}/${StoreUtils.rootGetters("getDeviceFingerPrint")}`,
                        source: "Web"
                    }
                }).then(response => {
                    //stop running
                    this.updateAppLoading(false);

                    // console.log('response ==>>', response);

                    //retrieve login Data
                    let responseData = response.data;

                    if (responseData.responsecode === '00'){
                        console.table(responseData);

                        //set dataOnLogin in the store to the login response
                        this.updateDataOnLogin(responseData);

                        // change the currentComponent in the store to 'dashboard'
                        this.updateCurrentComponent('inside')
                    }else {
                        // console.log('Default Log In Error')
                    }
                }).catch(error => {
                    //stop running
                    this.updateAppLoading(false);

                    // display error notification
                    // console.log('Default Log In Error (Catch)')
                })
            }
        },
        mounted(){
            this.$nextTick(()=>{})
        },
    }
</script>

<style scoped>
    a{
        color: #fff;
    }
</style>